export default {
  name: 'ZkCol',

  props: {
    span: {
      type: Number,
      default: 24
    },
    offset: Number,
    pull: Number,
    push: Number,
    xs: [Number, Object],
    sm: [Number, Object],
    md: [Number, Object],
    lg: [Number, Object]
  },

  computed: {
    gutter() {
      return this.$parent.gutter
    },
    style() {
      var ret = {}

      if (this.gutter) {
        ret.paddingLeft = this.gutter / 2 + 'px'
        ret.paddingRight = ret.paddingLeft
      }
      return ret
    }
  },
  render(h) {
    let { style } = this
    let classList = []
    let types = ['span', 'offset', 'pull', 'push']
    types.forEach(prop => {
      if (this[prop]) {
        classList.push(
          prop !== 'span' ? `zk-col-${prop}-${this[prop]}` : `zk-col-${this[prop]}`
        )
      }
    })
    let sizes = ['xs', 'sm', 'md', 'lg']
    sizes.forEach(size => {
      if (typeof this[size] === 'number') {
        classList.push(`zk-col-${size}-${this[size]}`)
      } else if (typeof this[size] === 'object') {
        let props = this[size]
        Object.keys(props).forEach(prop => {
          classList.push(
            prop !== 'span' ? `zk-col-${size}-${prop}-${props[prop]}` : `zk-col-${size}-${props[prop]}`
          )
        })
      }
    })

    return (
      <div
        class={['zk-col', classList]}
        style={style}>
        {this.$slots.default}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/packages/col/src/col.js